// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Z43H","rootMobile":"styles_rootMobile__Dd-BP"};